import { render, staticRenderFns } from "./ClientRegister.vue?vue&type=template&id=d6c24868&scoped=true"
import script from "./ClientRegister.vue?vue&type=script&lang=js"
export * from "./ClientRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c24868",
  null
  
)

export default component.exports